import React, { memo, useEffect } from 'react';
import NotificationMenu from './notifications';
import useTopPanel from 'hooks/useTopPanel';
import LanguageMenu from './LanguageMenu';
import DailyCurrency from './DailyCurrency';
import CallsHistory from './calls-history/CallsHistory';
import Navigators from './Navigators';
import User from './User';
import Calculator from './calculator';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import useMenu from 'hooks/useMenu';

const TopPanel = ({ printRef }) => {
  const { component } = useTopPanel();
  const { hasMenu } = useMenu();

  useEffect(() => {
    const element = printRef?.current;
    const pageWidth = element.scrollWidth;
    const printWidth = 794; // A4 width in px (96 DPI)

    const scale = printWidth / pageWidth;

    element.style.setProperty('--print-scale', scale);
  }, [printRef]);

  const onPrint = useReactToPrint({
    content: () => printRef?.current,
    documentTitle: `calculation`,
    pageStyle: `
          @media print {
            @page { size: landscape; margin: 0mm; }
          }
          body {
            -webkit-print-color-adjust: exact;
          }
        `,
  });

  return (
    <div className='with-max-width h-16 border-b border-b-[#E5E9EB] bg-[#F8F9FB]'>
      <div
        id='top-panel'
        className='top-panel-wrapper py-4 px-4 flex items-center justify-between z-[10] h-16 with-max-width'
      >
        <div className='top-panel-tools flex items-center justify-between w-full mx-2 gap-[10px]'>
          <Navigators />
          {component}
          <div className='flex items-center gap-2 ml-auto'>
            <div>
              <Link className='no-underline' to='tel:+99878555110'>
                <Button
                  variant='contained'
                  size='small'
                  sx={{ padding: '6px 12px' }}
                >
                  <div className='flex flex-col gap-0 items-start whitespace-nowrap'>
                    <div className='text-[11px] text-gray-200 leading-[13px]'>
                      Tex support
                    </div>
                    <span className='text-[12px] leading-[14px]'>
                      78 555-11-10
                    </span>
                  </div>
                </Button>
              </Link>
            </div>
            <div>
              <CallsHistory />
            </div>
            <div>
              <LanguageMenu />
            </div>
            <div>
              <NotificationMenu />
            </div>
            <Link
              className='no-underline'
              to='https://marketplace.smartqur.uz/'
            >
              <Button variant='base' size='small' sx={{ padding: '6px 12px' }}>
                <i className='bi bi-shop' />
              </Button>
            </Link>
            {hasMenu('HR') && (
              <div>
                <Link className='no-underline' to='/admin/hr'>
                  <Button
                    variant='base'
                    size='small'
                    sx={{ padding: '6px 12px' }}
                  >
                    <i className='bi bi-eye' />
                  </Button>
                </Link>
              </div>
            )}
            <div>
              <Button
                onClick={onPrint}
                variant='base'
                size='small'
                sx={{ padding: '6px 12px' }}
              >
                <i className='bi bi-printer' />
              </Button>
            </div>
            <div>
              <Calculator />
            </div>
            <div>
              <DailyCurrency />
            </div>
            <div>
              <User />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(TopPanel);
